import { Construction, Flame } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

/**
 * Permit burns section — placeholder / under construction.
 *
 * This will host permit-burn applications and their approval workflow. The
 * detailed requirements are still being defined; for now it's a stub so the
 * nav entry and route exist.
 */
export default function PermitBurnsIndex() {
  return (
    <div className="mx-auto max-w-3xl p-4 sm:p-6">
      <div className="mb-6 flex items-center gap-3">
        <Flame className="h-6 w-6 text-primary" />
        <h1 className="text-2xl font-semibold">Permit burns</h1>
        <Badge variant="secondary">Under construction</Badge>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Construction className="h-5 w-5 text-muted-foreground" />
            Coming soon
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 text-sm text-muted-foreground">
          <p>
            This is where permit burns and their applications will live —
            capturing requests, approvals, conditions and scheduled burn dates.
          </p>
          <p>
            The workflow is still being scoped. Nothing here is live yet; check
            back soon.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
